// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__39W4T","column":"style_column__8lie4","row":"style_row__1FgdD"};